<!-- <div class="container-fluid padMob webView" style="padding-left: 15px; padding-right: 0px;"> -->
    <div class="container-fluid padMob webView " style="padding-left: 20px; padding-right: 30px;" #epltable>
        <div class="row ">
            <div class="col-md-12 col-12 col-sm-12 padHeder" style="padding-bottom: 15px; padding-right: 0px;">
                <div class="col-md-3 col-12 col-sm-12 pad0 inLneBlk lblHeader newHeader" style="float: left;">
                    <h2 style="font-size: 25px;"> Inventory Details</h2>
                </div>
                <div class="col-md-9 col-12 col-sm-12 pad0 inLneBlk txtRight" style="padding-top: 5px;">
                    <div class="input-icons search" style="display: inline-block; float: right; width: 100%;">
                            <span class="fa fa-search bgWhite" style="position: relative; left: 20px; top: -5px; color: #999;"></span>
                            <input class="form-control formCtlFltr brdrRadius3 " ng-model="search.term" placeholder="Search" matInput
                              (keyup)="applyFilter($event)" #input
                              style=" background-color: white !important; text-align: left; display: inline-block; padding-left: 25px !important; padding: 1px 0px 0px; box-shadow: none; width: 18%; font-size: 13px; height: 30px !important; margin: 0px;"
                              type="text">
    
                        <!-- <div *ngIf="!modalshow" class="com-md-3 col-lg-3" -->
                        <!-- style="display: inline-block; text-align: right; padding: 0px;"> -->
                        <span class="darkBlueButton" style="font-size: 13px; display: inline-block; padding: 6px 9px !important; float: right;
                            margin-left: 7px;" (click)="backBtn()">
                            <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                        </span>
                        <!-- </div> -->
    
                        <!-- <span class="btn orangeButton fntSz brdrRadius3" (click)="opentagSearch(tagSearch)" title="Tag Search"
                            style="cursor: pointer; margin-left: 7px; line-height: 19px; float: right; padding: 6px 10px !important;">
                            <span><i class="fa fa-filter" aria-hidden="true"></i></span>
                        </span> -->
    
                        <span class="btn orangeButton fntSz brdrRadius3" (click)="exportToExcelActivities()" title="Export to Excel"
                            style="cursor: pointer; margin-left: 7px; line-height: 19px; float: right; padding: 6px 10px !important;"><span><i
                                    class="fa fa-file-excel-o" aria-hidden="true"></i></span></span>
                       
                        <span class="label greenBadge fntSz brdrRadius3" title="Total Values" style="border: 1px solid; padding: 4px 8px; margin-left: 7px; line-height: 23px; float: right; background: white;"
                            *ngIf="totalValue > 0 && isRateView">₹
                            {{totalValue | lacFormat : 0}}</span>
                            <!-- <span class="label greenBadge fntSz"
                            style="padding: 6px 10px; margin-right: 10px; line-height: 23px; float: right;" *ngIf="totalValue > 0 && myCurrency.code == 'INR'">₹
                            {{totalValue | lacFormat : 0}}</span> -->
    
                        <span class="label greenBadge fntSz brdrRadius3" style="border: 1px solid; padding: 4px 8px; margin-left: 7px; line-height: 23px; float: right; background: white;"
                            *ngIf="Items.length  > 0"><span>
                                Total Items : {{Items.length | lacFormat:0 }}</span>
                        </span>
                    </div>
                </div>
                <!-- 
                <span class="btn btn-darkBlue fntSz" (click)="exportToExcel()" title="Export to Excel"
                    style="cursor: pointer; margin-left: 10px; line-height: 23px; float: right; padding: 5px 11px;"><span><i
                            class="fa fa-file-excel-o" aria-hidden="true"></i></span></span> -->
            </div>
            <div class="col-md-12 col-12 col-sm-12 padHeder" style="padding-top: 0px; padding-bottom: 0px; padding-right: 0px;">
                <span class="label brownBadge-wb fntSz brdrRadius3 {{filter == 0 ? 'brownBadge-wb-active' : ''}}" (click)="typeFilter(0)"
                    style="cursor: pointer; margin-left: 0px;"><span>All</span></span>
                <span class="label greenBadge-wb fntSz brdrRadius3 {{filter == 1 ? 'greenBadge-wb-active' : ''}}" (click)="typeFilter(1)"
                    style="cursor: pointer; margin-left: 5px;"><span style="margin-right: 5px"><i class="fa fa-square"
                        aria-hidden="true"></i></span> <span>Products</span></span>
                <span class="label orangeBadge-wb fntSz brdrRadius3 {{filter == 2 ? 'orangeBadge-wb-active' : ''}}" (click)="typeFilter(2)"
                    style="cursor: pointer; margin-left: 5px;"><span style="margin-right: 5px"><i class="fa fa-square"
                        aria-hidden="true"></i></span> <span>Materials</span></span>
                <span class="label darkBlueBadge-wb fntSz brdrRadius3 {{filter == 3 ? 'darkBlueBadge-wb-active' : ''}}" (click)="typeFilter(3)"
                    style="cursor: pointer; margin-left: 5px"><i class="fa fa-square" aria-hidden="true"></i><span
                    style="margin-left: 5px">Spares</span></span>
                <span class="label blueBadge-wb fntSz brdrRadius3 {{filter == 4 ? 'blueBadge-wb-active' : ''}}" (click)="typeFilter(4)"
                    style="cursor: pointer; margin-left: 5px; margin-right: 5px;"><span style="margin-right: 5px"><i class="fa fa-square"
                        aria-hidden="true"></i></span><span>Assemblies</span></span>
                <span class="label greenBadge fntSz brdrRadius3" style="border: 1px solid; padding: 4px 8px; margin-left: 7px; line-height: 22px; float: right; background: white;"
                    *ngIf="currValuation == 1 || currValuation == 2 || currValuation == 3"><span>
                        Valuation : {{currValuation == 1 ? 'Standard Cost' : (currValuation == 2 ? 'Last Purchase Price' : (currValuation == 3 ? 'Historical Average' : ''))}}
                    </span>
                </span>
            <!-- <span class="label yellowBadge fntSz {{filter == 3 ? 'activeYellow' : ''}}" (click)="typeFilter(3)"
                style="cursor:pointer;margin-left:5px; "><span style="margin-right:5px"><i class="fa fa-square"
                    aria-hidden="true"></i></span><span>Services</span></span> -->
        
                <div class="col-sm-12 col-md-12 col-xs-12 pad0" style="display: flex; align-items: center; column-gap: 8px; margin-top: 15px;">
                    <!-- All Stores -->
                    <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 150px;" [(ngModel)]="storeId" (change)="changeStore()" *ngIf="storeList.length > 1">
                        <option value="0">All Stores</option>
                        <option *ngFor="let s of storeList" [ngValue]="s.StrID">{{s.sNm}}</option>
                    </select>
                    <!-- Category -->
                    <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 150px;" id="txtItem" [(ngModel)]="data.categoryID" tabindex="1" (change)="filterCategory()">
                        <option [value]="0">All Category</option>
                        <option *ngFor="let a of categories" [value]="a.cid">{{a.cnm}}</option>
                    </select>
                    <!-- Sub Category -->
                    <select [disabled]="subCategoryList.length == 0" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 150px;" [(ngModel)]="data.SubCategoryID" tabindex="1" (change)="filterSubCategory()">
                        <option [value]="0">All Sub Category</option>
                        <option *ngFor="let x of subCategoryList" [value]="x.sid">{{x.snm}}</option>
                    </select>
                    <!-- All Stocks -->
                    <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 150px;" [(ngModel)]="selected.stockType" tabindex="1" (change)="filterStockItems()">
                        <option [value]="0">All Non-Zero Stock</option>
                        <option [value]="1" *ngIf="allStoreRights">All Stock Items</option>
                        <option [value]="2" *ngIf="allStoreRights">Understock Items Only</option>
                    </select>
                    <!-- Importance -->
                    <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 150px;" [(ngModel)]="selected.imp" (change)="typeFilter(6)">
                        <option value="3">All Importance Levels</option>
                        <option value="0">Low</option>
                        <option value="2">Normal</option>
                        <option value="1">High</option>
                    </select>
                    <!-- Tags -->
                    <input type="text" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" list="Tags" placeholder="Enter Tag" style="display: inline-block; width: 150px; background-color: white !important;" [(ngModel)]="itemTag.search">
                    <datalist id="Tags" tabindex="1">
                        <option *ngFor="let i of tag" value="{{i}}">
                    </datalist>
                    <!-- <div>
                    <i class="zmdi zmdi-plus orangeText"
                    style="font-size: 20px; vertical-align: middle; cursor: pointer;"
                    (click)="getTagSearchData(1)"></i>
                    </div> -->
                    <span class="greenBadge brdrRadius3" style="cursor: pointer; line-height: 20px; padding: 5px 10px;" (click)="filterApply()">
                        <i class="zmdi zmdi-check"></i>
                    </span>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="selectedTags.length>0" style="display: flex; justify-items: start; flex-wrap: wrap; column-gap: 8px; row-gap: 4px; margin-top: 15px; padding-left: 0; padding-right: 0;">
                    <div style="display: inline-block; border: 1px solid #ddd; padding: 3px 10px; font-size: 13px; border-radius: 3px; background:rgb(31 98 142 / 10%) !important; color:#15304a" *ngFor="let x of selectedTags; let i = index">
                    <span>{{x}}</span>
                    <span style="margin-left: 5px; cursor: pointer;" (click)="removeTagSearchNew(i)">
                        <i class="zmdi zmdi-close"></i>
                    </span>
                    </div>
                </div>
    
                <!-- <span class="label brownBadge fntSz" style="cursor: pointer; margin-right: 5px;" title="Store"
                        *ngIf="storeList.length > 1" (click)="selectStore(storeSelect)"> <span
                            style="font-size: 14px; margin-right: 8px;">
                            <i class="zmdi zmdi-store"></i></span>{{storeName}}
                    </span> -->
                <!-- <span class="label darkBlueBadge fntSz bgwhite darkBlueBrdr brdrRadius3" style="padding: 3px 8px !important; cursor: pointer; margin-right: 5px;" title="Store"
                *ngIf="storeList.length > 1" (click)="selectStore(storeSelect)"> <span
                    style="font-size: 14px; margin-right: 8px;">
                    <i class="zmdi zmdi-store"></i></span>{{storeName}}</span></span>
                <span class="label darkBlueBadge fntSz bgwhite darkBlueBrdr brdrRadius3" style="padding: 3px 8px !important; cursor: pointer;" *ngIf="!zeroQtyItems"><label
                        style="margin-bottom: 0px; cursor: pointer;">
                        <input class="chkbox-darkblue" type="checkbox" (change)="filterDepleted()" [(ngModel)]="depletedItems"
                            style="vertical-align: text-top; position: relative; top: 1px;"> Show Depleted
                        Items</label></span>
                <span class="label darkBlueBadge fntSz bgwhite darkBlueBrdr brdrRadius3" style="padding: 3px 8px !important; cursor: pointer; margin-left: 5px;" *ngIf="!depletedItems"> <label
                    style="margin-bottom: 0px; cursor: pointer;"><input class="chkbox-darkblue" type="checkbox" (change)="filterIncludeZeroqty()"
                        [(ngModel)]="zeroQtyItems" style="vertical-align: text-top; position: relative; top: 1px;"> Include Zero Qty
                    Items </label></span> -->
            </div>
            
            <div class="stockDTable flexcroll " style="padding: 0px; margin: 0px; padding-top: 0px; margin-left: 15px; margin-top: 15px;">
                <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl" style="padding-left: 0px !important; padding-right: 0px; padding: 15px; padding-top: 0px;" 
                    #epltable>
                    <table mat-table [dataSource]="dataSource" matSort  style="width: {{ isRateView == true ? '135%' : '100%'}}; border-radius: 3px;">
                        <ng-container matColumnDef="ItemName">
                            <th class="header header-Table" style="cursor: pointer;width: 100px !important;" mat-header-cell
                                *matHeaderCellDef mat-sort-header>
                                <label style="cursor: pointer;">Item</label>
                                <!-- <div class="filter" floatLabel="never" style="width: 20%;display: none;">
                                    <input matInput class="form-control seachInput" [formControl]="ItemNameFilter" placeholder="Group"
                                    style="border: none; border-bottom: 1px solid; font-size: 14px;">
                                </div> -->
                            </th>
                            <td mat-cell *matCellDef="let item" style="width: 12%; text-align: left;">
                                <div class="inLneBlk" style="width: 85%  !important;">
                                    {{item.ItemName}} </div>
                                <div class="inLneBlk" style="width: 15% !important; text-align: left;">
                                    <i class="fa fa-square" aria-hidden="true" style="color:#e88421"
                                        [hidden]="item.TypeID != 2 " title="Material"></i>
                                    <!-- <i class="fa fa-square" aria-hidden="true" style="color:#DAA520" [hidden]="item.TypeID != 4"
                                        title="Service"></i> -->
                                    <i class="fa fa-square" aria-hidden="true" style="color:#2b7fb3" [hidden]="item.TypeID != 4"
                                        title="Assembly"></i>
                                    <i class="fa fa-square" aria-hidden="true" style="color:#4caf50" [hidden]="item.TypeID != 1"
                                        title="Product"></i>
                                    <i class="fa fa-square" aria-hidden="true" style="color:#15304a" [hidden]="item.TypeID != 3"
                                        title="Spare"></i>
                                </div>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="ItemCode">
                            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                            <label style="cursor: pointer;">Code</label>
                            <div class="filter" floatLabel="never" style="display: none;">
                                <input matInput class="form-control seachInput" [formControl]="ItemCodeFilter" placeholder="Opening"
                                style="border: none; border-bottom: 1px solid; font-size: 14px;">
                            </div>
                            </th>
                            <td mat-cell *matCellDef="let item" style="text-align: left;">{{item.ItemCode }}</td>
                        </ng-container>
    
                        <ng-container matColumnDef="Imp">
                            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                                <label style="cursor: pointer;">Importance</label>
                                <div class="filter" floatLabel="never" style="display: none;">
                                <input matInput class="form-control seachInput" [formControl]="ImpFilter" placeholder="Importance"
                                    style="border: none; border-bottom: 1px solid; font-size: 14px;">
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let item" style="text-align: left; cursor: pointer;"
                                (click)="openItemEidt(productEdit, item);">{{ item.ImpName }}</td>
                        </ng-container>
    
                        <ng-container matColumnDef="CatSubCatName">
                            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                            <label style="cursor: pointer;">Category</label>
                            <div class="filter" floatLabel="never" style="display: none;">
                                <input matInput class="form-control seachInput" [formControl]="CategoryFilter" placeholder="Debit"
                                style="border: none; border-bottom: 1px solid;  font-size: 14px;">
                            </div>
                            </th>
    
                            <td mat-cell *matCellDef="let item"  style="text-align: left; white-space: nowrap;">
                                {{ item.categoryName }} / {{item.subCategoryName.length > 0 ? item.subCategoryName[0].snm : ''}}
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="CurrQty">
                            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">
                            <label style="cursor: pointer; margin-left: 0px;">Qty</label>
                            </th>
                            <td mat-cell *matCellDef="let item" style="text-align: right; color: {{item.CurrQty < item.MinStockQty ? 'red' :'SKU'}};">
                                    {{item.CurrQty }}
                            </td>
                        </ng-container>
                      
                        <!-- <ng-container matColumnDef="CurrQty">
                            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef
                                mat-sort-header>
                                <label style="cursor: pointer; ">Qty</label>
                                <div class="filter" floatLabel="never">
                                    <input matInput class="form-control seachInput" [formControl]="CurrQtyFilter"
                                        placeholder="Credit"
                                        style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let item">
                                <div
                                    style="width: 1px  !important;text-align: right;color: {{item.CurrQty < item.MinStockQty ? 'red' :'SKU'}};">
                                    {{item.CurrQty }}
                                </div>
                            </td>
                        </ng-container> -->
    
                        <ng-container matColumnDef="SKU">
                            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                            <label style="cursor: pointer; padding-left: 15px;">Unit</label>
                            </th>
                            <td mat-cell *matCellDef="let item"
                            style="text-align: left; padding-left: 15px; color: {{item.CurrQty < item.MinStockQty ? 'red' :''}};">
                            {{item.SKU}}</td>
                        </ng-container>
            
                        <!-- <ng-container matColumnDef="SKU">
                            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef
                                mat-sort-header>
                                <label style="cursor: pointer;">Unit</label>
                                <div class="filter" floatLabel="never">
                                    <input matInput class="form-control seachInput" [formControl]="SKUFilter" placeholder="Closing"
                                        style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let item"
                                style="text-align: left;width: 500px!important;padding-left: 5px;color: {{item.CurrQty < item.MinStockQty ? 'red' :''}};">
                                {{item.SKU}}</td>
                        </ng-container> -->
    
            
                        <ng-container matColumnDef="DefStockRate">
                            <th [style.display]="(isRateView == true) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer;" arrowPosition="before">
                                <label style="cursor: pointer;"> Rate</label>
                                <div class="filter" floatLabel="never" style="display: none;">
                                    <input matInput class="form-control seachInput" [formControl]="StockValueFilter" placeholder="isHead"
                                    style="border: none; border-bottom: 1px solid; font-size: 14px;">
                                </div>
                            </th>
                            <td [style.display]="(isRateView == true) ? '' : 'none'" mat-cell *matCellDef="let item">
                                <div style="text-align: right;">₹
                                    {{item.DefStockRate | lacFormat : 1}}</div>
                            </td>
                        </ng-container>
    
    
                        <ng-container matColumnDef="DefPurchRate">
                            <th [style.display]="(isRateView == true) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer;" arrowPosition="before">
                                <label style="cursor: pointer;">Purch Cost</label>
                                <div class="filter" floatLabel="never">
                                </div>
                            </th>
                            <td [style.display]="(isRateView == true) ? '' : 'none'" mat-cell *matCellDef="let item">
                                <div style="text-align: right;"> ₹
                                    {{item.DefPurchRate | lacFormat : 1}}
                                </div>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="LastPurchRate">
                            <th [style.display]="(isRateView == true && currValuation == 2) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer; padding-left: 15px;" arrowPosition="before">
                                <label style="cursor: pointer;" >LPP</label>
                            </th>
                            <td [style.display]="(isRateView == true && currValuation == 2) ? '' : 'none'" mat-cell *matCellDef="let item">
                                <div style="text-align: right; padding-left: 15px;"> ₹
                                    {{item.LastPurchRate | lacFormat : 1}}
                                </div>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="ValLPP">
                            <th [style.display]="(isRateView == true) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer; white-space: nowrap; padding-left: 15px;" arrowPosition="before">
                                <label style="cursor: pointer;" >{{(currValuation == 1 ? 'Std Cost' : (currValuation == 2 ? 'LPP' : (currValuation == 3 ? 'Hist Avg': '0')))}} Value</label>
                            </th>
                            <td [style.display]="(isRateView == true) ? '' : 'none'" mat-cell *matCellDef="let item">
                                <div style="text-align: right; white-space: nowrap; padding-left: 15px;"> ₹
                                    {{(currValuation == 1 ? item.ValStdCost : (currValuation == 2 ? item.ValLPP : (currValuation == 3 ? item.ValHistAvg : '0'))) | lacFormat : 1}}
                                </div>
                            </td>
                        </ng-container>
            
            
                        <ng-container matColumnDef="DefSaleRate">
                            <th [style.display]="(isRateView == true) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer; white-space: nowrap;" arrowPosition="before">
                                <label style="cursor: pointer;">Sale Price</label>
                            </th>
                            <td [style.display]="(isRateView == true) ? '' : 'none'" mat-cell *matCellDef="let item">
                                <div style="text-align: right;"> ₹
                                    {{item.DefSaleRate | lacFormat : 1}}
                                </div>
                            </td>
                        </ng-container>
            
            
                        <!-- <ng-container matColumnDef="ValStdCost">
                            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer; padding-left: 28px; width: 10%;">
                                <label style="cursor: pointer;">Std Cost</label>
                                
                                
                            </th>
                            <td mat-cell *matCellDef="let item">
                                <div style="text-align: right;width: 80px !important;">₹
                                    {{item.ValStdCost | lacFormat : 1}}
                                </div>
                            </td>
                        </ng-container> -->
            
                        <ng-container matColumnDef="HSN">
                            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer;" arrowPosition="before">
                                <label style="cursor: pointer;">HSN</label>
                                <div class="filter" floatLabel="never" style="display: none;">
                                    <input matInput class="form-control seachInput" [formControl]="HSNFilter" placeholder="isHead"
                                    style="border: none; border-bottom: 1px solid; width: 90%; font-size: 14px;">
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let item">
                                <div style="width: 55px!important; text-align: end;"> {{item.HSN }}</div>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="DefGSTRate">
                            <th [style.display]="(isRateView == true) ? '' : 'none'" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer;" arrowPosition="before">
                                <label style="cursor: pointer;">GST</label>
                                <div class="filter" floatLabel="never" style="display: none; ">
                                    <input matInput class="form-control seachInput" [formControl]="GstValueFilter" placeholder="isHead"
                                    style="border: none; border-bottom: 1px solid; width: 90%; font-size: 14px;">
                                </div>
                            </th>
                            <td [style.display]="(isRateView == true) ? '' : 'none'" mat-cell *matCellDef="let item">
                                <div style="text-align: right;width: 65px!important;">
                                    {{item.DefGSTRate | lacFormat : 1}} %
                                </div>
                            </td>
                        </ng-container>
            
                       
            
                        <ng-container matColumnDef="LeadTime">
                            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer; white-space: nowrap; padding-left: 15px;">
                                <label style="cursor: pointer;">Lead Time</label>
    
                                <div class="filter" floatLabel="never" style="display: none; ">
                                    <input matInput class="form-control seachInput" [formControl]="leadTimeFilter" placeholder="isHead"
                                    style="border: none; border-bottom: 1px solid; font-size: 14px;">
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let item">
                                <div style="padding-left: 15px;">
                                    {{item.LeadTime }} {{item.LeadTime== 1 ? 'day' : 'days' }}</div>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="MinStockQty">
                            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer; white-space: nowrap;" arrowPosition="before">
                                <label>Min Qty</label>
                                <div class="filter" floatLabel="never" style="display: none; ">
                                    <input matInput class="form-control seachInput" [formControl]="minStockFilter" placeholder="isHead"
                                    style="border: none; border-bottom: 1px solid; font-size: 14px;">
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let item" style="text-align: -webkit-right;">
                                <div style="text-align: right;width: 50px!important;">
                                    {{item.MinStockQty}}</div>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="Tags">
                            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer; padding-left: 10px;">
                                <label style="cursor: pointer;">Tags</label>
                                <div class="filter" floatLabel="never" style="display: none; ">
                                    <input matInput class="form-control seachInput" [formControl]="tagFilter" placeholder="isHead"
                                    style=" cursor: pointer;border: none; border-bottom: 1px solid; width: 90%; font-size: 14px;">
                                </div>
                                
                                
                            </th>
                            <td mat-cell *matCellDef="let item" style="padding-left: 10px;">
                                <div style="width: 100px!important;">{{item.Tags }}</div>
                            </td>
                        </ng-container>
            
                        <ng-container matColumnDef="Notes">
                            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                                style="text-align: right; cursor: pointer;">
                                <label style="cursor: pointer;display:none;">Notes</label>
                                <div class="filter" floatLabel="never" style="width: 90%;" style="display: none;">
                                    <input matInput class="form-control" placeholder="isHead"
                                        style="border: none; border-bottom: 1px solid; font-size: 14px;">
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let item">
                                <i class="fa fa-sticky-note stickyNotes" *ngIf="item.Details" title="{{item.Details}}"></i>
                            </td>
                        </ng-container>
    
                        <!-- <ng-container matColumnDef="Actions">
                            <th class="header header-Table" mat-header-cell *matHeaderCellDef style="text-align: right;">
                                <div class="filter" floatLabel="never" style="width: 90%; display: none;">
                                    <input matInput class="form-control" placeholder="isHead"
                                        style="border: none; border-bottom: 1px solid; font-size: 14px;">
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let item" style="text-align: right;">
                                <div class="lableBtnOrange inLneBlk" style="border-radius: 50%; cursor: pointer;"
                                    (click)="openItemEidt(productEdit, item);">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </div>
                                <div class="lableBtnGray inLneBlk" style="border-radius: 50%; margin-left: 10px;"
                                    (click)="DeleteItem(item.ItemID)" *ngIf="item.CurrQty == 0">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </div>
                            </td>
                        </ng-container> -->
            
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let item; columns: displayedColumns" style="vertical-align: top;"></tr>
                        <tr class="mat-row" *matNoDataRow style="text-align: left;">
                        <td class="mat-cell" colspan="4" style="background-color: #fff;">
                            <div class="nrf" style="border-radius: 3px;">No stock items found.</div>
                        </td>
                    </tr>
                    </table>
            
                    <!-- <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10, 20]" style="margin-top: 15px;">
                    </mat-paginator> -->
                    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10, 20]" style="width: {{ isRateView == true ? '135%' : '100%'}};">
                    </mat-paginator>
                </div>
                   
            </div>
            <div  class="col-md-12 col-12 col-sm-12 pad0" style="padding: 15px; margin-top: 0px;" *ngIf="Items.length == 0">
                <div class="nrf brdrRadius3" style="cursor: pointer; ">No item found.</div>
            </div>
          
              <div class="col-md-12 col-sm-12 col-xs-12" style="margin-top: 10px;padding-left: 15px;">
                  <a href="https://biziverse.com/support/support.html?abt=inventory" target="_blank" class="trngDarkBlueBtn" style="text-decoration: none; margin-right: 10px; display: inline-block; ">
                    <i class="zmdi zmdi-help-outline" style="margin-right: 5px; font-size: 16px; vertical-align: middle;"></i>
                    <span style="margin-top: 10px;">Training Materials</span> 
                  </a>
                  <span *ngIf="!showLearningMaterial && showOnBoarding" (click)="openHelpPage(12)" class="trngDarkBlueBtn">
                    <i class="fa fa-question" style="margin-right: 5px; vertical-align: initial; font-size: 16px;"></i> Need Help
                  </span>
              </div>
            
        </div>
    </div>
    
    
    <!-- <div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 15px; margin-top: 15px;" *ngIf="Items.length == 0">
        <div class="nrf" style="cursor: pointer;">No data matching the filter</div>
    </div> -->
    
    
    
    <ng-template #productEdit let-modal>
        <!--Body-->
        <div class="modal-body" style="padding: 0px;">
            <app-product-detail [ItemID]="ItemID"></app-product-detail>
        </div>
    </ng-template>
    
    <!-- edit qty -->
    <ng-template #qtyEdit let-modal>
        <!--Header-->
        <div class="modal-header">
            <div class="col-md-12 col-sm-12 col-12">
                <div class="row">
                    <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
                        <h4 class="modal-title"><span id="ApntmntHdr">Update Stock</span></h4>
                    </div>
                    <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
                        <i class="closeMdl zmdi zmdi-close" style="float: right;"
                            (click)="modal.dismiss('Cross click')"></i>
                    </div>
                </div>
            </div>
        </div>
        <!--Body-->
        <div class="modal-body">
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
                <div *ngFor="let s of selectedStoreQty">
                    <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-bottom: 10px;">
                        <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px; font-size: 14px;">
                            {{s.name}}
                        </div>
                        <div class="col-md-6 col-sm-6 col-6"
                            style="display: inline-block; padding: 0px; text-align: right; font-size: 14px;">
                            <div style="display: inline-block; margin-right: 10px;" *ngIf="!s.isEdit">{{s.qty}} {{s.unit}}
                            </div>
                            <div style="display: inline-block; width: 75%; margin-right: 10px;" *ngIf="s.isEdit">
                                <input type="text" class="form-control"
                                    style="height: 20px; text-align: right; width: 60%; display: inline-block;"
                                    [(ngModel)]="s.qty" (keyup)="enterQty(s)"> {{s.unit}}
                            </div>
                            <div class="inLneBlk editBtn" *ngIf="!s.isEdit" (click)="s.isEdit = !s.isEdit"
                                style="border-radius: 50%; cursor: pointer; display: inline-block;">
                                <i class="fa fa-pencil" aria-hidden="true"
                                    style="font-size: 13px; position: relative; bottom: 1.1px;"></i>
                            </div>
                            <div class="inLneBlk doneBtn" *ngIf="s.isEdit" (click)="saveReconcile(s)"
                                style="border-radius: 50%; cursor: pointer; display: inline-block;">
                                <i class="fa fa-check" aria-hidden="true"
                                    style="font-size: 13px; position: relative; bottom: 1.1px;"></i>
                            </div>
                        </div>
                    </div>
    
                </div>
            </div>
    
        </div>
        <!--Footer-->
        <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
    
        </div>
    </ng-template>
    
    
    <ng-template #tagSearch let-modal>
        <!--Header-->
    
        <div class="col-md-12 col-sm-12 col-12">
            <div class="row">
                <div class="col-md-9 col-sm-10 col-10" style="padding: 15px; padding-bottom: 0px;">
                    <h4> Filter by Tags</h4>
                </div>
                <div class="col-md-3 col-sm-2 col-2" style="padding: 15px; padding-bottom: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
                </div>
            </div>
        </div>
    
        <!--Body-->
        <div class="modal-body">
            <div class="col-md-12 col-sm-12 col-12" style="padding-left: 0px;">
                <!-- <div *ngFor="let s of selectedStoreQty"> -->
                <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-bottom: 10px;">
                    <span>
                        <input type="text" class="form-control" list="Tags" placeholder="Enter Tag" style="width: 65%; display: inline-block;" [(ngModel)]="itemTag.search">
                            <datalist id="Tags" tabindex="1"> <option *ngFor="let i of tag" value="{{i}}"></datalist>
                            <i class="zmdi zmdi-plus" style="color: #e88421; margin-left: 20px; font-size: 20px; vertical-align: middle; cursor: pointer;"
                                (click)="getTagSearchData(1)"></i>
                    </span>
                </div>
            </div>
    
            <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="selectedTags.length>0" style="padding-right: 0px; left: -8px; padding-left: 0px">
                <div style="display: inline-block; border: 1px solid #ddd; padding: 5px 10px; padding-top: 3.5px; border-radius: 25px; margin-top: 5px; margin-left: 5px; background:rgb(31 98 142 / 10%) !important; color:#15304a"
                    *ngFor="let x of selectedTags; let i = index">
                    <span>
                        {{x}}
                    </span>
                    <span style="margin-left: 10px; cursor: pointer;" (click)="removeTagSearch(i)">
                        <i class="zmdi zmdi-close"></i>
                    </span>
                </div>
                <!-- <option *ngFor="let i of selectedTags ">{{selectedTags[i]}} -->
            </div>
    
        </div>
        <!--Footer-->
        <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
            <span style="float: left;"><span class="btn btn-green brdrRadius3" (click)="tagSearchItem(selectedTags)"
                    style="line-height: 33px !important; font-size: 13px !important; padding: 0px 15px;"><i class="zmdi zmdi-check" aria-hidden="true"
                        style="position: relative; top: 3px; font-size: 18px"></i> <span
                        style="margin-left: 5px;">Apply</span></span></span>
            <!-- <div class="col-md-6 col-xs-6 col-sm-6" style="padding-left: 0px;">
            <i class="btn btn-orange" >Apply</i>
          </div> -->
        </div>
    </ng-template>